/* global axios */
import ApiClient from './ApiClient';

class ResolutionReportsAPI extends ApiClient {
  constructor() {
    super('conversation_resolutions', { accountScoped: true });
  }

  get({ page, from, to, user_ids, inbox_id, q } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        since: from,
        until: to,
        user_ids,
        inbox_id,
        q,
      },
    });
  }

  download({ from, to, user_ids, inbox_id, q } = {}) {
    return axios.get(`${this.url}/download`, {
      params: { since: from, until: to, user_ids, inbox_id, q },
      responseType: 'blob',
    });
  }
}

export default new ResolutionReportsAPI();
